import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {UntypedFormBuilder, UntypedFormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../../../../core/services/AuthServices/auth.service";
import {UserProfileService} from "../../../../core/services/user.service";
import {ValidatorMatchPass} from "../../../../shared/Validators/validator.matchpass";

@Component({
  selector: 'app-loan-app-sign-up',
  templateUrl: './loan-app-sign-up.component.html',
  styleUrls: ['./loan-app-sign-up.component.scss']
})
export class LoanAppSignUpComponent implements OnInit {
  index_no: string;
  signupForm: UntypedFormGroup;
  submitted = false;
  error = '';
  successmsg = false;

  // set the current year
  year: number = new Date().getFullYear();
  loading: boolean;

  get f() {
    return this.signupForm?.controls;
  }
  constructor(
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private userService: UserProfileService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(parameter => {
      this.index_no = parameter.index_no;
    });

    this.signupForm = this.formBuilder.group({
      username: [{value: this.index_no, disabled: true}, Validators.required],
      password: ['', Validators.required],
      password2: ['', [Validators.required, ValidatorMatchPass]],
    },
      {
        validator: ValidatorMatchPass('password', 'password2'),
      });
  }

  onSubmit() {
    console.log(this.f.password2.errors);
    this.submitted = true;

  }

}
